<div class="row mb-2">
    <div class="col-6">
        <h5 class="appTooltip" appTooltip="{{consts.TOOLTIP_MESSAGE}}" tooltipPosition="right">
            {{consts.TITLE}}
            <mat-icon svgIcon="hub_info"></mat-icon>
        </h5>
    </div>
    <div class="col text-end sort-by">
        <span>{{consts.LABEL_SORT}}</span>
        <mat-select [(value)]="selected" [disabled]="isListEmpty$ | async" placeholder="{{consts.PLACEHOLDER_SORT}}"
            (selectionChange)="changeSort($event)">
            <mat-option [value]="sortType.ALPHA">{{consts.LABEL_SORT_ALPHA}}</mat-option>
            <mat-option [value]="sortType.GROUP">{{consts.LABEL_SORT_GROUP}}</mat-option>
        </mat-select>
        <button (click)="openFavoritesDialog()" class="fav-button">
            {{consts.BUTTON_ADD_FAVORITES}}
        </button>
    </div>
</div>
<ng-template #favItemTemplate let-item>
    <div class="flex-item align-items-center">
        <span (click)="openLink(item.link)" class="flex-child tools-name" appInsightsTrack
            [eventData]="{title: item.name, link: item.link}" loc="Tools & Resources" action="Go to">
            {{item.name}}
        </span>
        <div class="flex-child icon">
            <mat-icon
                svgIcon="hub_trash"
                class="trash-icon favorite"
                (click)="unfavoriteLink(item)"
                tooltipPosition="top"
                appTooltip="{{consts.TOOLTIP_UNFAVORITE}} {{item.name}}"
                appInsightsTrack
                [eventData]="{title: item.name, link: item.link}"
            >
            </mat-icon>
            <mat-icon
                *ngIf="item.customLink === true"
                svgIcon="hub_editfile"
                class="edit-icon favorite"
                (click)="editFavoriteLink(item)"
                tooltipPosition="top"
                appTooltip="{{consts.TOOLTIP_EDIT}} {{item.name}}"
                appInsightsTrack
                [eventData]="{title: item.name, link: item.link}"
            >
            </mat-icon>
        </div>
        <div class="flex-child icon">
            <mat-icon
                class="arrow-icon"
                svgIcon="hub_arrow_right"
                (click)="openLink(item.link)"
                tooltipPosition="top"
                appTooltip="{{consts.TOOLTIP_GOTO}} {{item.name}}"
                appInsightsTrack
                [eventData]="{title: item.name, link: item.link}"
            >
            </mat-icon>
        </div>
    </div>
</ng-template>
<div class="row">
    <div class="col-12">
        <div class="tools-link-container">
            <div class="tools">
                <ng-container *ngIf="favData$ | async as favData; else loading">
                    <div *ngIf="isListEmpty$ | async; else notEmpty" class="row fav-empty">
                        <h2>{{consts.LABEL_NO_FAVORITES_MAIN}}</h2>
                        <h4>{{consts.LABEL_NO_FAVORITES_SUB}}</h4>
                        <mat-icon svgIcon="hub_fav_empty"></mat-icon>
                    </div>
                    <ng-template #notEmpty>
                        <ng-container *ngIf="selected === sortType.GROUP">
                            <div class="row">
                                <div class="col-12 cus-fav-heading">
                                    {{consts.LABEL_CUSTOM_FAVORITES}}
                                </div>
                                <div class="col-12">
                                    <hr />
                                </div>
                                <div *ngFor="let item of favData.value[0]" class="tools-container">
                                    <ng-template [ngTemplateOutlet]="favItemTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
                                </div>
                                <div class="col-12 fav-heading">
                                    {{consts.LABEL_FAVORITES}}
                                </div>
                                <div class="col-12">
                                    <hr />
                                </div>
                                <div *ngFor="let item of favData.value[1]" class="tools-container">
                                    <ng-template [ngTemplateOutlet]="favItemTemplate"
                                        [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="selected === sortType.ALPHA">
                            <div *ngFor="let item of favData.value" class="tools-container">
                                <ng-template [ngTemplateOutlet]="favItemTemplate"
                                    [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
                            </div>
                        </ng-container>
                    </ng-template>
                </ng-container>
            </div>
            <ng-template #loading>
                <div class="loading-spinner">
                    <mat-spinner [diameter]="50"></mat-spinner>
                </div>
            </ng-template>
        </div>
    </div>
</div>
